module.exports = __webpack_public_path__ + "static/media/future.ba37221a.jpg";